namespace TabAurous.OMS {
    export interface LabourMasterForm {
        AttributeId: Serenity.StringEditor;
        ItemTypeId: Serenity.LookupEditor;
        ProductTypeId: Serenity.LookupEditor;
        CategoryId: Serenity.LookupEditor;
        SubCategoryId: Serenity.LookupEditor;
        BrandId: Serenity.LookupEditor;
        CollectionId: Serenity.LookupEditor;
        SuperTypeId: Serenity.LookupEditor;
        StoneColorId: Serenity.LookupEditor;
        ShapeId: Serenity.LookupEditor;
        SieveId: Serenity.LookupEditor;
        QualityId: Serenity.LookupEditor;
        StoneSizeId: Serenity.LookupEditor;
        ProcessId: Serenity.LookupEditor;
        CalcOnId: Serenity.LookupEditor;
        IsCustomerItem: Serenity.BooleanEditor;
        SettingId: Serenity.LookupEditor;
        RateType: RateTypeEditor;
        PurStdLabour: Serenity.DecimalEditor;
        SaleStdLabour: Serenity.DecimalEditor;
        FromWt: WeightEditor;
        ToWt: WeightEditor;
        MinLabour: Serenity.DecimalEditor;
        MaxLabour: Serenity.DecimalEditor;
    }

    export class LabourMasterForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.LabourMaster';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!LabourMasterForm.init)  {
                LabourMasterForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.BooleanEditor;
                var w3 = RateTypeEditor;
                var w4 = s.DecimalEditor;
                var w5 = WeightEditor;

                Q.initFormType(LabourMasterForm, [
                    'AttributeId', w0,
                    'ItemTypeId', w1,
                    'ProductTypeId', w1,
                    'CategoryId', w1,
                    'SubCategoryId', w1,
                    'BrandId', w1,
                    'CollectionId', w1,
                    'SuperTypeId', w1,
                    'StoneColorId', w1,
                    'ShapeId', w1,
                    'SieveId', w1,
                    'QualityId', w1,
                    'StoneSizeId', w1,
                    'ProcessId', w1,
                    'CalcOnId', w1,
                    'IsCustomerItem', w2,
                    'SettingId', w1,
                    'RateType', w3,
                    'PurStdLabour', w4,
                    'SaleStdLabour', w4,
                    'FromWt', w5,
                    'ToWt', w5,
                    'MinLabour', w4,
                    'MaxLabour', w4
                ]);
            }
        }
    }
}
